import InternalDescriptions from './Descriptions';
import Item from './Item';

type InternalDescriptionsType = typeof InternalDescriptions;

interface DescriptionsProps extends InternalDescriptionsType {
  Item: typeof Item;
}

const Descriptions = InternalDescriptions as DescriptionsProps;

Descriptions.Item = Item;

export default Descriptions;
